package com.dotdrives.repository
import com.dotdrives.client.DashboardClient
import com.dotdrives.client.ReminderClient
import com.dotdrives.model.*
import kotlin.time.Instant
interface DashboardRepository {
 suspend fun snapshot(orgId:String,asOf:Instant):Result<DashboardSnapshot>
 suspend fun queue(orgId:String,asOf:Instant):Result<List<DashboardQueueItem>>
 suspend fun acknowledge(orgId:String,donationId:String):Result<Unit>
 suspend fun completeReminder(orgId:String,reminderId:String):Result<Unit>
}
class SupabaseDashboardRepository(private val client:DashboardClient=DashboardClient(),private val reminders:ReminderClient=ReminderClient()):DashboardRepository {
 override suspend fun snapshot(orgId:String,asOf:Instant)=runCatching {client.snapshot(orgId,asOf)}
 override suspend fun queue(orgId:String,asOf:Instant)=runCatching {client.queue(orgId,asOf)}
 override suspend fun acknowledge(orgId:String,donationId:String)=runCatching {client.acknowledge(orgId,donationId)}
 override suspend fun completeReminder(orgId:String,reminderId:String)=runCatching {reminders.complete(orgId,reminderId)}
}
